import './Footer.css'
import { Link } from 'react-router-dom'
import Logo from './Logo'
import { BUSINESS as B, CATEGORIES } from '../data/site'

export default function Footer() {
  return (
    <footer className="footer" id="contact">
      <div>
        <Logo onDark />
        <p>{B.tagline}</p>
        <p><a href={`https://instagram.com/${B.instagram}`} target="_blank" rel="noreferrer">Instagram @{B.instagram}</a></p>
      </div>
      <div>
        <h4>Shop</h4>
        <ul>{CATEGORIES.slice(0, 6).map(c => <li key={c}><Link to={`/shop?category=${encodeURIComponent(c)}`}>{c}</Link></li>)}
          <li><Link to="/shop">View all</Link></li></ul>
      </div>
      <div>
        <h4>Help</h4>
        <ul>
          <li><Link to="/#repair">Book a repair</Link></li>
          <li><a href={`https://wa.me/${B.whatsapp}`} target="_blank" rel="noreferrer">Chat on WhatsApp</a></li>
          <li><a href={`mailto:${B.email}`}>{B.email}</a></li>
        </ul>
      </div>
      <address>
        <h4>Visit us</h4>
        <p>{B.address}</p>
        <p><a href={`tel:${B.phone.replace(/\s/g, '')}`}>{B.phone}</a><br /><a href={`tel:${B.phone2.replace(/\s/g, '')}`}>{B.phone2}</a></p>
      </address>
      <small>© {new Date().getFullYear()} iPOINT. All rights reserved.</small>
    </footer>
  )
}